/**
 * Page to show payment rails payout source.  Used in the customer components (show customer's
 * funding sources), and FundingSources (my funding sources).
 * 
 * NOTE:  PaymentRails has since renamed itself Trolley
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import Address from '../ui/Address'

import PropTypes from 'prop-types';
import { Button, Grid, Paper, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import ServerError from '../ui/ServerError';


import LoadingSpinner from '../ui/LoadingSpinner';
import PaymentSourceUpdateMutation from './PaymentSourceUpdateMutation';
import PaymentSourceCreateMutation from './PaymentSourceCreateMutation';
import AccountUpdateMutation from '../account/AccountUpdateMutation';

import AccountInformationFetch from './AccountInformationFetch';
import PRPaymentSourceFetch from './PRPaymentSourceFetch';

const abEnvironment = new AbEnvironment();

const PaymentRailsPayoutQuery = graphql`
query PaymentRailsPayoutQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountName
    paymentSourceTsByAccountId(condition: {psType: 3}) {
      totalCount
      nodes {
        psId
        psOrder
      }
    }    
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
    marginTop: 16,
  },
  
  sectionBlock: {
    marginBottom: 12,  
  },

  error: {
    backgroundColor: theme.palette.error.light,
  }
});

class PaymentRailsPayout extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      accountFetched: false,
      addressFilled: false,
 
      country:    '',
      state:      '',
      city:       '',
      postalCode: '',
      address1:   '',
      address2:   null,
      showPaymentRailsWidget: false,
      
      resellerName: '',
      activeOnly:  0,

      existingPaymentRailsPSFetched: false,
      existingPaymentRailsPS: false,
      psStatusIn: null,
      psId: null,

      paymentRailsStatus: 'active',
      link: null,
      accountId:    abEnvironment.getUserAttribute("a_id"),
      height: 590
    };

    this.uInfo = null;

        // .bind() creates a NEW instance of the target function
    // store this instance in a variable and use in componentDidMount() and componentWillUnmount()
    this.resizeHeight = this.resizeHeight.bind(this);
    // if you code it this way:
    //  window.addEventListener('resize', this.resizeHeight.bind(this));
    //  window.removeEventListener('resize', this.resizeHeight.bind(this));
    // this is wrong! as mentioned above .bind() creates a NEW instance of the target function
    // therefore the removeEventListener() is not removing the original reference on the addEventListener()
    // and the event and handler function is executing on other pages

  }
   
  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  resizeHeight(e) {

    var widgetEvent = e.data;   

    if (widgetEvent.event === "document.height") {
      //console.log(JSON.stringify('Got a document event ' + widgetEvent.data));
      //added a bit more as it was too short 04/26/23 
      this.setState({height: widgetEvent.data + 100});
    }
  }

 
  updateBillingAddress = (acctId) => {


    const { address1, address2, city, state, country, postalCode } = this.state;

    AccountUpdateMutation.commit(acctId, null, null, null, null,
                                 null, null, null, null,
                                 address1, address2, city, state, country, postalCode,
                                 null, null, null, null, null, 
                                 null, null, null)
    .then(response => {
      // console.log('Account updated')

      if (acctId === abEnvironment.getUserAttribute("a_id")) {
        //if user is updating their own, set their local storage.
        abEnvironment.setUserAttribute('a_address1', address1);
        if (address2 != null) {
          abEnvironment.setUserAttribute('a_address2', address2);
        }
        abEnvironment.setUserAttribute('a_city', city);
        abEnvironment.setUserAttribute('a_state', state);
        abEnvironment.setUserAttribute('a_country', country);
        abEnvironment.setUserAttribute('a_postalCode', postalCode);

      }

      this.setState({addressFilled: true});   

      window.location.reload();
       
     })
    .catch(error => {
      // console.log('Got error: ' + error);
    });
  }

  componentDidMount() {
 
    const { logError } = this.props.auth;

    //console.log('componentDidMount');
      let accountId = this.props.accountId
      
      var addressFilled = false;

      AccountInformationFetch.fetch(accountId).toPromise()
      .then(aif => {
          if (aif.accountTByAccountId.address1 !== null && aif.accountTByAccountId.address1 !== '') {
            addressFilled = true;
          }

          var resellerName = "";
          if (this.props.auth.isUnauthenticatedCustomer()) {
            resellerName = aif.accountTByAccountId.accountTByParentId.accountName;
          }

          this.setState({accountFetched: true, resellerName: resellerName, addressFilled: addressFilled});    

          /* this calls the backend which gets a secure URL to pass to the iFrame */
          /* if the address is not filled, they will be prompted to enter and then the form reloads */
          if (addressFilled && aif.accountTByAccountId.accountStatus === 0) {
            this.retrievePaymentRailsForm();
          } 
      })
      .catch(err => {
        logError('Exception in PaymentRailsPayout.js: ' + err);
      })

      PRPaymentSourceFetch.fetch(accountId).toPromise()
      .then(prps => {
          //console.log(JSON.stringify(prps));

          if (prps.allPaymentSourceTs.totalCount >= 1) {
            this.setState({existingPaymentRailsPSFetched: true, existingPaymentRailsPS: true, psStatusIn: prps.allPaymentSourceTs.nodes[0].psStatusIn, psId: prps.allPaymentSourceTs.nodes[0].psId})
          } else {
            this.setState({existingPaymentRailsPSFetched: true})

          }

      })
      .catch(err => {
        logError('Exception in PaymentRailsPayout.js: ' + err);
      })

      this.getPaymentRailsRecipientStatus();

      /* payment rails will tell us the size of the widget, this is adding a listener for that and resizing accordingly */
      window.addEventListener("message", this.resizeHeight);


  }

  /*
  *
  *  This method calls our backend API that follows a payment rails pattern for getting a secure link to their user interface
  */ 
  retrievePaymentRailsForm = () => {

    const { callPartnerApi, logError } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();


    let payload = {
      operation: "getPaymentRailsUXLink",
      params: {
        pJwt: aPjwt,
        accountId: this.props.accountId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      
      this.setState({link: response.link});

    })
    .catch(error => {
      logError('Exception in PaymentRailsPayout.js: ' + error);
    });
  }

  componentWillUnmount() {
    //console.log('componentWillUnmount');
    window.removeEventListener('resize', this.resizeHeight);

    //see comments in StepperResellerPayoutSource
    if (this.props.unmountStart) {
      this.props.unmountStart();
    }

    /* This is a little involved but here is what is going on.  Inside the payment rails iFrame, our users could do 
    anything including deleting all their payout accounts.  When they do this, payment rails makes them an incomplete
    status.  This is important for us as we should then suspend the account.  The converse is also true.  Our account
    may by suspended but then they go into payment rails and become active, we would set ours to unsuspended.  All 
    of this is first determined by querying their status */

    const { callPartnerApi, logError } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let paymentRailsID = null;
    let paymentRailsStatus = null;

    let accountId = abEnvironment.getUserAttribute("a_id");
    let contactFirstName = abEnvironment.getUserAttribute("a_firstName");
    let contactLastName = abEnvironment.getUserAttribute("a_lastName");
    let contactEmail = abEnvironment.getUserAttribute("a_email");

    let payload = {
      operation: "getPaymentRailsRecipient",
      params: {
        pJwt: aPjwt,
        accountId: this.props.accountId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {

      if (response[0]) {
        paymentRailsID = response[0].id;
        paymentRailsStatus = response[0].status;
      }
      //console.log(JSON.stringify(paymentRailsID))
      //this.setState({link: response.link});

    })
    .then(response => {
 

      if (this.state.existingPaymentRailsPS === false && paymentRailsStatus === 'active') {

        //there was not already a payment source of type 3, lets add since they are active in PR
        return PaymentSourceCreateMutation.commit(accountId, 3, 0, 0, 0, 0,
          contactLastName, contactFirstName, contactEmail, null,
          null, null, null, null, null, null, 
          null, null, null,
          "paymentrails", paymentRailsID, null)

      } else if (this.state.existingPaymentRailsPS === true && this.state.psStatusIn === 1 && paymentRailsStatus === 'active') {

        //if the payout payment source was suspended but now PR says active, activate ours now and place in last order
        //console.log('activating payment source for ' + this.state.psId);
        return PaymentSourceUpdateMutation.commit(this.state.psId, null, null, 0, 0);

      } else if (this.state.existingPaymentRailsPS === true && this.state.psStatusIn === 0 && paymentRailsStatus !== 'active') {
        
        //if the payout payment source not suspended but now PR says inactive, suspend ours now.
        //console.log('suspending payment source');
        //return PaymentSourceSuspendMutation.commit(accountId, this.state.psId, 1);

        const { callPartnerApi } = this.props.auth;

     
        let aPjwt = abEnvironment.getPjwt();
    
        let payload = {
          operation: "suspendExistingTrolleyPaymentSource",
          params: {
            pJwt: aPjwt,
            accountId: accountId,
            psId: this.state.psId
          }
        };
    
        return callPartnerApi('appbind/generic',
                       'POST',
                       payload
        )
        .then(resp => {
          return resp.json();
        })
        .then(response => {
          console.log(JSON.stringify(response));
        })    
        .catch(error => {
          console.log('Error: ' + error);

        });
    
      } else if (this.state.existingPaymentRailsPS === true && paymentRailsStatus === 'active') {
        //console.log('nothing to do')
      }

    }).then((jresp) => {
          
        //see comments in StepperResellerPayoutSource
        if (this.props.unmountStop) {
          this.props.unmountStop();
        }

    })
    .catch(error => {
      logError('Exception in PaymentRailsPayout.js: ' + error);
    });
  }


  getPaymentRailsRecipientStatus() {
    
    if (this.props.auth.isAuthenticatedReseller() || this.props.auth.isAuthenticatedVendor()) {
      const { callPartnerApi, logError } = this.props.auth;

      let aPjwt = abEnvironment.getPjwt();
      
      let payload = {
        operation: "getPaymentRailsRecipient",
        params: {
          pJwt: aPjwt,
          accountId: this.props.accountId
        }
      };
  
      callPartnerApi('appbind/generic',
                      'POST',
                      payload
      )
      .then(resp => {
        return resp.json();
      })
      .then(response => {
        
        if (response[0] && response[0].status) {
          this.setState({paymentRailsStatus: response[0].status});
        }
      }).catch(error => {
        logError('Exception in PaymentRailsPayout.js: ' + error);
      });
    }
  }

  goTo = (route) => {
    this.props.history.push(`/${route}`);
  }

  render() {

    const classes = this.props.classes;

    const { isAuthenticatedReseller, logError } = this.props.auth;

    // This page is for resellers only to establish payout account through Payment Rails.
    // 

    let cp = this.props.cp;
    let acctId = this.props.accountId;

    // Rendering settings
    let headerText           = null;
    let summaryText          = null;


    var billingAddressInstructions = "";
    if ((cp === 'customer') && isAuthenticatedReseller()) {
      billingAddressInstructions = "Please enter your customer's billing address";
    } else {
      billingAddressInstructions = "Please enter your billing address";
    }

    // Buttons are disabled if the account or resellers account is suspended 
    let disableAdd = false;
    if (this.props.accountStatus === 1) {
      disableAdd = true;
    }
    if (this.props.resellerStatus && this.props.resellerStatus === 1) {
      disableAdd = true;
    }

    //in case we need to capture billing address
    let address = {
      country:    this.state.country,
      state:      this.state.state,
      city:       this.state.city,
      postalCode: this.state.postalCode,
      address1:   this.state.address1,
      address2:   this.state.address2
    };

    var isAddressComplete = false;
    if (this.state.address1 !== '' && this.state.city !== '' && this.state.state !== '' && this.state.country !== ''  && this.state.postalCode !== '') {
        isAddressComplete = true;
    }

    //make sure link is only from payment rails.
    let linkValid = false;
    if (this.state.link && this.state.link.startsWith('https://widget.paymentrails.com/')) {
      linkValid = true;
    }

    var subscriptionReturn = localStorage.getItem('subscriptionReturn');
    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={PaymentRailsPayoutQuery}
        variables={{accountId: acctId}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            let paymentSourceCount = 0;
            if (props.accountTByAccountId != null && props.accountTByAccountId.paymentSourceTsByAccountId && props.accountTByAccountId.paymentSourceTsByAccountId.totalCount > 0) {
              //there is a header row that we do not want counted as a payment source.
              paymentSourceCount = props.accountTByAccountId.paymentSourceTsByAccountId.totalCount;
            }


            if (!this.state.accountFetched || !this.state.existingPaymentRailsPSFetched) { 

              return (
                <div>
                  <LoadingSpinner/>
                </div>
              );
            } else if (this.props.accountStatus !== 0) {

              return (
                
                <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                  <Grid item xs={12}>
                    <Grid container spacing={0} direction="column" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="h6">Payout</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {this.props.accountStatus === 1 &&
                    <Grid item  xs={12}> 
                      <Typography variant="body2">Your account has been suspended.</Typography>
                    </Grid>
                  }

                  {this.props.accountStatus === 2 &&
                    <React.Fragment>
                      <Grid item  xs={12}> 
                        <Typography variant="body2">In order for you to connect a bank account or credit card, we need to know you a bit better. You can use a government id to verify your identity in less than five minutes!</Typography>
                      </Grid>
                      <Grid item  xs={12}> 
                        <Button color="primary" 
                                variant="contained"
                                onClick={() => { this.goTo('home');}}>
                            Verify account
                        </Button>
                      </Grid>
                    </React.Fragment>
                  }


                </Grid>
              );
              
            } else if (!this.state.addressFilled && this.state.accountFetched) {

              return (
                <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                  <Grid item xs={12}>
                    <Grid container spacing={0} direction="column" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="h6">{headerText}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">{summaryText}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="h6" className={classes.sectionTitle}>
                      {billingAddressInstructions}
                    </Typography>
                  </Grid>
        
                  <Grid item xs={12} style={{marginBottom: 16}}>
                    <Address
                      showRequired={false}
                      address={address}
                      regionLabel={"Region"}
                      setCountryCodeState={this.setCountry}
                      setRegionCodeState={this.setRegion}
                      setCityState={this.setCity}
                      setPostalCodeState={this.setPostalCode}
                      setAddress1State={this.setAddress1}
                      setAddress2State={this.setAddress2}
                    />
                  </Grid>
                  <Grid item > 
                        
                      <Button color="primary" 
                              variant="contained"
                              disabled={!isAddressComplete} 
                              onClick={() => { this.updateBillingAddress(acctId);}}>
                        Save
                      </Button>
                    
                  </Grid>


                </Grid>

                
              );
            } else if (subscriptionReturn && paymentSourceCount !== 0) {
              //this can happen after ACH addition because it does a window reload.
              var subscriptionLink = '/subscription?customerAppId=' + subscriptionReturn + '&fp=Funding';
              localStorage.removeItem('subscriptionReturn');
              return (<Redirect push to={subscriptionLink} />);
            } else if (disableAdd) {
              //not in proper state
              return (<Typography>Your account is not currently allowed to establish a payout method</Typography>);
            } else if (this.state.link && linkValid) {
              return (
                <Paper className={classes.paper}>
                  <iframe id="payment-rails-widget" title="Payment Rails" src={this.state.link} width="100%" height={this.state.height} frameBorder="0"></iframe>
                </Paper>
              );
            } else {

              return <div><LoadingSpinner/></div>
            }
          }
          return <div><LoadingSpinner/></div>
        }}
      />
    );
  }
}
  
PaymentRailsPayout.propTypes = {
    classes: PropTypes.object.isRequired,
  };
      
  export default withStyles(styleSheet)(PaymentRailsPayout);
